const AutoSuggestParamsActionTypes = {
  SET_CATALOG_VIEWS: 'SET_CATALOG_VIEWS',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  SET_AUTOSUGGEST_MODAL_STATE: 'SET_AUTOSUGGEST_MODAL_STATE'
};

export default AutoSuggestParamsActionTypes;
